<template>

<div class="chart" :style="style">

</div>

</template>

<script>

export default {
	
    props: ['data'],

    computed: {

        style: function() {

            var style = {
                backgroundImage: ''
            }

            var pie = []

            var total = 0

            this.$_.each(this.data, function(item) {

                total += item.value

            })

            var colors = [
                '#1A4860',
                '#8ad9b1',
                '#958ad9',
                '#d98ad9',
                '#d9b38a'
            ]

            var rolling = 0

            this.$_.each(this.data, function(item) {

                var percent = (100 / total) * item.value

                rolling += percent

                pie.push(colors[pie.length] + ' 0%, ' + colors[pie.length] + ' ' + Math.floor(rolling) + '%')

            })

            style.backgroundImage = 'conic-gradient(' + pie.join(', ') + ')'

            return style

        }
        
    }

}

</script>

<style scoped>

.chart {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    transition: transform 100ms linear;
    z-index: 1;
}

.chart:after {
    display: block;
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #fff;
    margin-left: -2px;
    margin-top: -2px;
}

.chart:hover {
    transform: scale(3);
    z-index: 2;
}

</style>
